// Setup guide — unit tab switching (OBD / hardwire / battery)
document.addEventListener('DOMContentLoaded',function(){
(function(){
  var tabs=[].slice.call(document.querySelectorAll('.sg-tab'));
  var bar=document.querySelector('[data-sg-bar]');
  function set(id,scroll){
    tabs.forEach(function(t){
      var on=t.dataset.tab===id;
      t.classList.toggle('is-on',on);
      t.setAttribute('aria-selected',on?'true':'false');
      t.tabIndex=on?0:-1;
      document.getElementById('panel-'+t.dataset.tab).hidden=!on;
    });
    try{localStorage.setItem('mw-setup-tab',id)}catch(e){}
    if(history.replaceState)history.replaceState(null,'','#'+id);
    if(scroll){var y=bar.getBoundingClientRect().top+window.pageYOffset-1;if(window.pageYOffset>y)window.scrollTo({top:y,behavior:'smooth'})}
  }
  tabs.forEach(function(t,i){
    t.addEventListener('click',function(){set(t.dataset.tab,true)});
    t.addEventListener('keydown',function(e){
      if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;
      e.preventDefault();
      var n=tabs[(i+(e.key==='ArrowRight'?1:tabs.length-1))%tabs.length];
      n.focus();set(n.dataset.tab,true);
    });
  });
  var start=(location.hash||'').replace('#','');
  if(start!=='obd'&&start!=='hw'&&start!=='bat'){try{start=localStorage.getItem('mw-setup-tab')}catch(e){}}
  if(start==='obd'||start==='hw'||start==='bat')set(start,false);
})();

});
